import { Modal as AntModal } from 'antd';
import css from './modal.module.scss';
import { EFDeleteForDialog } from '../svg/Header';

/**
 * @description: 此模态框为基础弹窗，去掉头部和尾部，children内容完全手写，保留原有antd基础props和方法
 */
export default function EfModal({ children, closeIcon, ...rest }: any) {
    const classList = [css.efInput];
    const props = { ...rest };

    if (rest.className) {
        classList.push(rest.className);
        props.className = classList.join(' ');
    }

    if (!props.title) {
        props.title = null;
    }

    return (
        <AntModal {...props} wrapClassName="ef-base-modal" footer={null} closeIcon={closeIcon || <EFDeleteForDialog />} destroyOnClose>
            <div>{children}</div>
        </AntModal>
    );
}
